import { readGlobal } from 'oasis-os-common';
import { getCookie, isCookieEnabled } from 'oasis-os-utils';

export const getCookieAnalytics = () => {
  const analyticsCookie = readGlobal('$.global.value.functionalConfig.cookieMng.display');
  // Check if the cookie banner is enabled and cookies are enabled
  if (analyticsCookie && isCookieEnabled()) {
    // Check if the pwa_banner cookie is accepted
    if (getCookie('pwa_banner')) return true;
    else return false;
  }
  //In case of Ontrust returning true
  return true;
};
